import _ from 'underscore';
import React, { useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getStoreStyles } from '../styles/get-store-style';
import { ValidatedStoreView } from './store-select-view';
import { ValidatedStoreCreation } from './store-select-creation';
import { ValidatedStoreSelectLoading } from './store-select-loading';

export function StoreSelectContainer(props) {
  const {
    campaign,
    campaignObjective,
    data,
    onStoreDataLoaded,
    showProductCollections,
    hideFeedLabelAndCountry,
    onRenderCustomLoadingComponent,
  } = props;

  const i18n = useContext(I18nContext);
  const legacyI18n = useMemo(() => window.globalLegacyI18n.get('$/i18n!legacy/global'), []);
  const classes = useDefaultStyles(getStoreStyles);
  const [isLoading, setIsLoading] = useState(true);
  const [stores, setStores] = useState({});
  const [countries, setCountries] = useState({});
  const hasStores = _.keys(stores).length > 0;
  const campaignSaved = campaign.data.Id && campaign.data.Id > 0;

  const onStoresLoadingDone = useCallback(({ stores: newStores, countries: newCountries }) => {
    setStores(newStores);
    setCountries(newCountries);
    setIsLoading(false);
    if (_.isFunction(onStoreDataLoaded)) {
      onStoreDataLoaded({ stores: newStores, countries: newCountries });
    }
  }, [onStoreDataLoaded]);

  const [storesLoadingErrors, setStoresLoadingErrors] = useState([]);
  const onStoresLoadingError = useCallback((error) => {
    setStoresLoadingErrors([error]);
    setIsLoading(false);
    if (_.isFunction(onStoreDataLoaded)) {
      onStoreDataLoaded({ error });
    }
  }, [onStoreDataLoaded]);

  return (
    <div className={classNames('store-container', classes.intentTarget)}>
      <div className={classNames('strore-theme-info-pre-selected-items', classes.preSelectedItemsStyle)}>
        {isLoading || !_.isEmpty(storesLoadingErrors) ?
          <ValidatedStoreSelectLoading
            i18n={i18n}
            legacyI18n={legacyI18n}
            campaignObjective={campaignObjective}
            isLoading={isLoading}
            onLoadingDone={onStoresLoadingDone}
            onLoadingError={onStoresLoadingError}
            loadingErrors={storesLoadingErrors}
            validationProps={{
              initialValue: data,
              data,
            }}
            formErrorProps={{
              filter: () => false, // TODO: map store-related server errors
            }}
            onRenderCustomLoadingComponent={onRenderCustomLoadingComponent}
          />
          :
          <div className={classes.storeSelectContent}>
            {campaignSaved ?
              <ValidatedStoreView
                hasStores={hasStores}
                stores={stores}
                countries={countries}
                validationProps={{
                  initialValue: data,
                  data,
                }}
                formErrorProps={{
                  filter: () => false, // TODO: map store-related server errors
                }}
                showProductCollections={showProductCollections}
              />
              :
              <ValidatedStoreCreation
                hasStores={hasStores}
                stores={stores}
                countries={countries}
                campaignObjective={campaignObjective}
                validationProps={{
                  initialValue: data,
                  data,
                }}
                formErrorProps={{
                  filter: () => false, // TODO: map store-related server errors
                }}
                showProductCollections={showProductCollections}
                hideFeedLabelAndCountry={hideFeedLabelAndCountry}
              />}
          </div>
        }
      </div>
    </div>
  );
}

StoreSelectContainer.propTypes = {
  campaign: PropTypes.shape({
    data: PropTypes.shape({
      Id: PropTypes.number,
    }),
  }).isRequired,
  campaignObjective: PropTypes.string.isRequired,
  data: PropTypes.shape({}).isRequired,
  onStoreDataLoaded: PropTypes.func,
  showProductCollections: PropTypes.bool,
  hideFeedLabelAndCountry: PropTypes.bool,
  onRenderCustomLoadingComponent: PropTypes.func,
};

StoreSelectContainer.defaultProps = {
  onStoreDataLoaded: undefined,
  showProductCollections: false,
  hideFeedLabelAndCountry: false,
  onRenderCustomLoadingComponent: null,
};
